import React from "react";
import Container from "../components/Layouts/Container";
import BlogDetail from "../components/Blog/BlogDetail";

const BlogDetailPage = () => {
  return (
    <Container>
      <BlogDetail />
    </Container>
  );
};

export default BlogDetailPage;
